import {environment} from '../../environments/environment';
export class AppSettings {
  /**
   * Determine whether Chat feature is available for new influencer app or not
   * @returns {boolean}
   */
  static isDisableChat() {
    return environment.newInfluencerPlatform.isDisableChat;
  }

  /**
   * Checking whether Homepage is activated for new influencer app or not
   * @returns {boolean}
   */
  static isDisableHomepage() {
    return environment.newInfluencerPlatform.isDisableHomePage;
  }

  /**
   * Determine whether Campaign feature is available for new influencer app or not
   * @returns {boolean}
   */
  static isDisableCampaign() {
    return environment.newInfluencerPlatform.isDisableCampaign;
  }

  /**
   * Determine whether Campaign History feature is available for new influencer app or not
   * @returns {boolean}
   */
  static isEnableCampaignHistory() {
    return environment.featureFlags.isEnableCampaignHistory;
  }

  /**
   * Determine whether Campaign feature is available for new influencer app or not
   * @returns {string}
   */
  static influencerProgramMarketingLink() {
    return environment.newInfluencerPlatform.marketingLink;
  }

  /**
   * Determine whether new Campaign Flow feature is available for new influencer app or not
   * @returns {string}
   */
  static isActiveNewCampaignFlow() {
    return environment.featureFlags.newCampaignFlow;
  }

  static getActivePlatformList() {
    return environment.activePlatforms;
  }

    /**
   * Get FB info for authentication
   * @returns {string}
   */
  static getFBInfo() {
    return {
      facebookAppId: environment.facebookAppId,
      fbRedirectUri: environment.fbRedirectUri,
      fbAppState: environment.fbAppState,
      fbChannelAuthorizeUri: environment.authorizeChannelUri
    };
  }

  /**
   * Determine whether Campaign Flow feature is available for new influencer app or not
   * @returns {string}
   */
  static isCampaignInfluencerDetails() {
    return environment.featureFlags.isCampaignInfluencerDetails;
  }

  /**
   * Determine whether sorting feature is available for Best Performing Influencer
   * @returns {boolean}
   */
  static isEnableBestPerformingInfluencerSorting() {
    return environment.featureFlags.isEnableBestPerformingInfluencerSorting;
  }

  /**
   * Determine whether request review feature is available for group
   * @returns {boolean}
   */
  static isRequestReview() {
    return environment.featureFlags.isRequestReview;
  }

    /**
   * Get default timer
   * @returns {number}
   */
  static getDefaultTimer() {
    return Number(environment.defaultTimer);
  }

  /**
  * Determine whether new demographic design is available or not
  * @returns {boolean}
  */
  static isRedesignDemographic() {
    return environment.featureFlags.isRedesignDemographic;
  }

  /**
   * get list of scopes for facebook authorization
   * @returns {string}
   */
  static facebookAuthScopes() {
    return environment.facebookScopes;
  }

  /**
  * Determine whether channel followers is available or not on influencer page
  * @returns {boolean}
  */
  static isEnableChannelFollowers() {
    return environment.featureFlags.isEnableChannelFollowers;
  }

  /**
   * Get Sign Up Link
   * @returns {boolean}
   */
  static signUpLink() {
    return environment.signUpLink;
  }

  /**
   * get feature flag for discover follower
   * @returns {boolean}
   */
  static isEnableDiscoverFollower() {
    return environment.featureFlags.discoverFollower;
  }

  /**
   * get mmi login link
   * @returns {string}
   */
  static mmiLoginLink() {
    return environment.mmiLoginUrl;
  }

  /**
   * get mmi logout link
   * @returns {string}
   */
   static mmiLogoutLink() {
    return environment.mmiLogoutUrl;
  }

  /**
   * get FAQ link
   * @returns {boolean}
   */
  static faqLink() {
    return environment.faqLink;
  }

  /**
   * get MMI HubSpot Form ID
   * @returns {boolean}
   */
  static mmiHubSpotFormId() {
    return environment.mmiHubSpotFormId;
  }

  /**
   * get feature flag for influencer review
   * @returns {boolean}
   */
  static isEnableInfluencerReview() {
    return environment.featureFlags.enableInfluencerReview;
  }

  /**
   * get chargebee site
   * @returns {boolean}
   */
  static cbSite() {
    return environment.cbSite;
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/app-settings.ts